// extracted by mini-css-extract-plugin
module.exports = {"fluidImage":"ImageText_fluidImage__3cKtz","imageText":"ImageText_imageText__2yT9T","signupBtn":"ImageText_signupBtn__2aWAC"};